export default "__VITE_ASSET__N2699QCM__"